import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="container footer bg-light">
      <div className="container mt-5">
        <div className="row">
          {/* Contact Us Section */}
          <div className="col-md-4 col-sm-6 footer-contact mt-3">
            <h5>Location</h5>
            <p>29, Mothilal street, T. nagar, Chennai, Tamil Nadu 600 017.</p>

            <div className="footer-social-icons">
              <a href="#">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="#">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="#">
                <i className="bi bi-youtube"></i>
              </a>
              <a href="#">
                <i className="bi bi-instagram"></i>
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="col-6 col-md-4 footer-links mt-3">
            <h5>Quick links</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/Privacy/Policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/Terms/Conditions">Term & Condition</a>
              </li>

              <li>
                <a href="/Faq/faq">FAQs</a>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div className="col-6 col-md-4 footer-company mt-3">
            <h5>Pages</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/3">Sale</a>
              </li>
              <li>
                <a href="/4">Shop</a>
              </li>
              <li>
                <a href="/contactus">Contact</a>
              </li>
            </ul>
          </div>

          {/* Business Section */}
          {/* <div className="col-md-3 col-sm-6 footer-business mt-3">
            <h5>Get In Touch</h5>
            <ul className="list-unstyled">
              <li>
                <p>
                  <a
                    href="mailto:sales@Kalanjiyam.com"
                    className="footer-email"
                  >
                    contact@Kalanjiyam.com
                  </a>
                </p>
              </li>
              <li>
                <p>
                  <a
                    href="mailto:sales@Kalanjiyam.com"
                    className="footer-email"
                  >
                    sales@Kalanjiyam.com
                  </a>
                </p>
              </li>
              <li>
                <p>
                  <a href="tel:1800979769" className="footer-phone">
                    +91 9998887774
                  </a>
                </p>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;